import { render, staticRenderFns } from "./Remark.vue?vue&type=template&id=3a1b3f2c&"
import script from "./Remark.vue?vue&type=script&lang=ts&"
export * from "./Remark.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports